(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-jj-product-list"] && !Shopify.designMode) return;
  try {
      
  document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('[data-custom-collection]')
    .forEach(function (section) {
      const tabs = section.querySelectorAll('[data-tab]');
      const products = section.querySelectorAll('[data-product-tabs]');
      const allAccessories = section.querySelector('[data-all-accessories]');

      const title = section.querySelector(
        '[data-custom-collection-title]'
      );

      const description = section.querySelector(
        '[data-custom-collection-description]'
      );

      const header = section.querySelector(
        '[data-custom-collection-header]'
      );

      function activateTab(selectedTab) {
        const activeTab = Array.from(tabs).find(function (tab) {
          return tab.dataset.tab === selectedTab;
        });

        if (!activeTab) return;

        tabs.forEach(function (tab) {
          const isActive = tab.dataset.tab === selectedTab;

          tab.classList.toggle('is-active', isActive);
          tab.setAttribute(
            'aria-selected',
            isActive ? 'true' : 'false'
          );

          tab.setAttribute(
            'tabindex',
            isActive ? '0' : '-1'
          );
        });

        products.forEach(function (product) {
          const productTabs = (
            product.dataset.productTabs || ''
          )
            .split(',')
            .map(function (value) {
              return value.trim();
            })
            .filter(Boolean);


          // don't show merch and bundle products in the "all" tab
          const isMerchProduct = productTabs.includes('merch');
          const isBundleProduct = productTabs.includes('bundles');

          const shouldShow =
            selectedTab === 'all'
              ? !isMerchProduct && !isBundleProduct
              : productTabs.includes(selectedTab);

          product.hidden = !shouldShow;
        });

        if (allAccessories) {
          allAccessories.hidden = selectedTab !== 'all';
        }

        if (title) {
          title.textContent =
            activeTab.dataset.title || '';
        }

        if (description) {
          const descriptionTemplate =
            activeTab.querySelector(
              '[data-description-template]'
            );

          if (descriptionTemplate) {
            const descriptionContent =
              descriptionTemplate.innerHTML.trim();

            description.innerHTML = descriptionContent;
            description.hidden = descriptionContent === '';
          } else {
            description.innerHTML = '';
            description.hidden = true;
          }
        }

        const url = new URL(window.location.href);

        if (selectedTab === 'all') {
          url.searchParams.delete('tab');
        } else {
          url.searchParams.set('tab', selectedTab);
        }

        window.history.replaceState({}, '', url);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateTab(tab.dataset.tab);

          if (header) {
            const offset = 400; // offset for sticky header and some padding

            const top =
              window.scrollY +
              header.getBoundingClientRect().top -
              offset;

            window.scrollTo({
              top: top,
              behavior: 'smooth'
            });
          }
        });

        tab.addEventListener('keydown', function (event) {
          const tabsArray = Array.from(tabs);
          const currentIndex = tabsArray.indexOf(tab);

          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight') {
            nextIndex =
              currentIndex === tabsArray.length - 1
                ? 0
                : currentIndex + 1;
          } else if (event.key === 'ArrowLeft') {
            nextIndex =
              currentIndex === 0
                ? tabsArray.length - 1
                : currentIndex - 1;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabsArray.length - 1;
          } else {
            return;
          }

          event.preventDefault();

          const nextTab = tabsArray[nextIndex];

          nextTab.focus();
          activateTab(nextTab.dataset.tab);
        });
      });

      const urlParams = new URLSearchParams(
        window.location.search
      );

      const requestedTab = urlParams.get('tab');

      const initialTab =
        Array.from(tabs).find(function (tab) {
          return tab.dataset.tab === requestedTab;
        }) ||
        section.querySelector('[data-tab].is-active') ||
        tabs[0];

      if (initialTab) {
        activateTab(initialTab.dataset.tab);
      }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-menu-1"]) return;
  try {
      
document.addEventListener(
  'mouseover',
  function (event) {
    const tab = event.target.closest('[data-megamenu-tab]');
    if (!tab) return;

    if (event.relatedTarget && tab.contains(event.relatedTarget)) {
      return;
    }

    const megaMenu = tab.closest('.mega-menu-1');
    if (!megaMenu) return;

    const selectedValue = tab.getAttribute('data-megamenu-tab');

    megaMenu.querySelectorAll('[data-megamenu-tab]').forEach(function (currentTab) {
      const isActive =
        currentTab.getAttribute('data-megamenu-tab') === selectedValue;

      currentTab.classList.toggle('is-active', isActive);
      currentTab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      currentTab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    megaMenu.querySelectorAll('[data-megamenu-panel]').forEach(function (panel) {
      const isActive =
        panel.getAttribute('data-megamenu-panel') === selectedValue;

      panel.classList.toggle('is-active', isActive);

      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  },
  true
);

  } catch(e) { console.error(e); }
})();
})();
